import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { hasActiveProductsToBeDisplayed } from "@qgiv/p2p-registration";
import {
    removeRegistration,
    selectAllRegistration,
} from "../../../../../redux/slices/registrationSlice";
import { selectHasParentRegistration } from "../../../../../redux/slices/appSettingsSlice";
import {
    selectAllP2pSettings,
    selectBaseUrl,
} from "../../../../../redux/slices/p2pSettingsSlice";
import { selectIsCms } from "../../../../../redux/slices/configSlice";
import { selectAllProducts } from "../../../../../redux/slices/productsSlice";
import CurrentRegistrationNav from "./CurrentRegistrationNav";

const ConnectedCurrentRegistrationNav = ({ isMediumScreen = false }) => {
    const { currentRegistration, registrations = [] } = useSelector(
        selectAllRegistration,
    );
    const hasParentRegistration = useSelector(selectHasParentRegistration);
    const { additionalRegistrants } = useSelector(selectAllP2pSettings);
    const products = useSelector(selectAllProducts);

    const location = useLocation();
    const { pathname } = location;

    const isCms = useSelector(selectIsCms);

    const enableCancel = currentRegistration > 0;
    const baseUrl = useSelector(selectBaseUrl);

    const isVisible =
        pathname === `${baseUrl}/form/registration` &&
        additionalRegistrants &&
        !hasParentRegistration;
    const participantNumber = currentRegistration + 1;
    const { First_Name = "", Last_Name = "" } =
        registrations[currentRegistration];

    const displayName =
        First_Name.length > 0 && Last_Name.length > 0
            ? `${First_Name} ${Last_Name}`
            : `Participant # ${participantNumber}`;

    const hasProducts = hasActiveProductsToBeDisplayed(products);

    const currentRegistrationNavProps = {
        currentRegistration,
        isMediumScreen,
        enableCancel,
        hasProducts,
        isCms,
        isVisible,
        registrations,
        displayName,
        baseUrl,
        removeRegistration,
    };

    return <CurrentRegistrationNav {...currentRegistrationNavProps} />;
};

ConnectedCurrentRegistrationNav.propTypes = {
    isMediumScreen: PropTypes.bool.isRequired,
};

export default ConnectedCurrentRegistrationNav;
